import { useEffect } from 'react';

import { setAppSidebarHidden } from './app-chrome-store';

/**
 * Asks the shell for the whole window while this component is mounted, and hands the
 * sidebar back on the way out. The shell mounts once for the entire dashboard route
 * group, so a page cannot reach it by composition and has to ask.
 *
 * Restoring on unmount is the load-bearing half: a page that leaves the flag set takes
 * the sidebar away from every route after it.
 */
export function useHideAppSidebar(hidden = true): void {
  useEffect(() => {
    setAppSidebarHidden(hidden);
    return () => setAppSidebarHidden(false);
  }, [hidden]);
}
